/*
    Feito por André Luís de Sousa Flor
    08/08/2018
*/
import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { modificaLoader } from '../../actions/LoaderActions';
import Select from 'react-select';
import _ from 'lodash';
import Navigation from '../Navigation/Navigation';
import { endpoint } from '../../helpers/constantes';

class CadastroVlan extends Component {
    

    constructor(props) {
        super(props);
        console.log('constructor cvl');
        this.state = {
            vlan:'',
            olt:'',
            olts: [],
            token: '',
            alert: {
             show: false,      
              title: 'Aviso',
              message: '',
              type: {
                warning: false,
                success: false,
                danger: false,
              }
            }
          }

        this.getOlts();
    }
    
      cadastra = async () => {
        this.props.modificaLoader(true);
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Authorization', `Bearer ${this.props.token}`);
        
        const body = {
            vlan: this.state.vlan,
            id_olt: this.state.olt.value
        }

        console.log('BODY', body);
        const resp = await fetch(`${endpoint}/vlan`, {
            headers: myHeaders,
            method: 'POST',
            body: JSON.stringify(body),
        });
        
      
        let respJson;
        if (resp.status !== 500) {
            respJson = await resp.json();

        } else {
            this.props.modificaLoader(false);
            this.setState({
                alert: {
                  show: true,             
                  title: 'Fracasso',
                  message: 'Erro interno do servidor!',
                  type: {
                    warning: false,
                    success: false,
                    danger: true,
                  }
                }
              });

              return;
        }
       

        if (resp.ok) {
            this.props.modificaLoader(false);
            this.setState({
                alert: {
                  show: true,             
                  title: 'Sucesso',
                  message: 'Operação realizada com sucesso!',
                  type: {
                    warning: false,
                    success: true,
                    danger: false,
                  }
                }
              });
              this.setState({vlan:'', olt:''});              
              return;
        }
        this.props.modificaLoader(false);
        this.setState({
            alert: {
              show: true,             
              title: 'Fracasso',
              message: respJson.msg,
              type: {
                warning: false,
                success: false,
                danger: true,
              }
            }
          });
      }

      limpar = () => {
        this.setState({
            olt: '',
            vlan: '',
        });        
      }

      getOlts = async () => {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Authorization', `Bearer ${this.props.token}`);
        const resp = await fetch(`${endpoint}/olts`, {
            headers: myHeaders
        });
        if (resp.ok) {

            const respJson = await resp.json();
            if (!_.isEqual(respJson, this.state.olts)) {;
                this.setState({olts: respJson});
                console.log('OLTS', this.state.olts);
            }
        }
    }

    renderOptions = () => {
        console.log('OLTS STATE');
        const options = this.state.olts.map(item => {
           return {
               value: item.id,
               label: item.nome
           }
        })

        return options;
    }

    handeChangeOlt = (selected) => {
        console.log('entrou handeChangeOlt');
        if (selected) {
            this.setState({olt: selected});
        }
    }
    render() { 
        console.log('ENTROU RENDER');
        return (  
            <Navigation history={this.props.history}>
            <div>
            <h1>Cadastre uma nova VLAN</h1>
            <p>Lembre-se de associá-la à OLT correta</p>            
            <form id="cad-vlan" onSubmit={(e) => {
                e.preventDefault()
                this.cadastra();
                }}>
              <div className="form-group">
                VLAN:
                <input
                ref={(input) => { this.nome = input; }} 
                className="form-control" 
                type="text"
                name="nome" 
                value={this.state.vlan} 
                onChange={event => this.setState({vlan: event.target.value})} 
                required
                autoFocus/>
              </div>
              <div className="form-group">
                OLT:
                <Select 
                onChange={this.handeChangeOlt}
                value={this.state.olt}
                className="basic-single"
                classNamePrefix="select"
                name="olt" 
                required 
                options={this.renderOptions()}
                />
                
              </div>
              <div className="form-group">
                <button 
                className="btn btn-outline-danger" 
                type="submit" 
                name="Cadastrar">
                Cadastrar
                </button>
                <button 
                className="btn btn-outline-secondary ml-3" 
                type="button" 
                onClick={this.limpar} 
                name="Limpar">
                Limpar
                </button>
              </div>
            </form>
            <SweetAlert {...this.state.alert.type}
              title={this.state.alert.title}
              show={this.state.alert.show}
              onConfirm={() => {
                  this.setState({ ...this.state, alert: {show: false, title: ''}})
                  this.nome.focus();
                  }}>
              {this.state.alert.message}
            </SweetAlert>
        </div>
        <div id="overlay"></div>
        </Navigation>
       
        );
    }
}
 
const mapStateToProps = state => ({
    token: state.LoginReducer.token,  
});
 
export default connect(mapStateToProps, { modificaLoader })(CadastroVlan);



// WEBPACK FOOTER //
// ./src/components/Vlans/CadastroVlan.js